import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/NotificationTray/NotificationTray.css'
import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import { LiveUpdateNotification } from 'interfaces/notifications'
import Icon from 'components/atoms/Icon'
import TextButton from 'components/atoms/buttons/TextButton'
import { dismissNotificationActionCreator } from 'actions/notificationsActions'
import Button from 'components/features/pfm/Button/Button'
import { flushLiveUpdateActionCreator } from 'actions/linkageActions'
import { AnalyticsClick } from 'components/features/pfm/AnalyticsClick/AnalyticsClick'

type LiveUpdateNotificationItemOwnProps = {
  notification: LiveUpdateNotification
}

type LiveUpdateNotificationItemStateProps = {
  isSubmitting: boolean
}

type LiveUpdateNotificationItemDispatchProps = {
  onFlushLiveUpdate: typeof flushLiveUpdateActionCreator.request
  onDismissNotification: (id: string) => void
}

type LiveUpdateNotificationItemProps =
  & LiveUpdateNotificationItemStateProps
  & LiveUpdateNotificationItemDispatchProps
  & LiveUpdateNotificationItemOwnProps

const LiveUpdateNotificationItemComponent: FC<LiveUpdateNotificationItemProps> = (props) => {
  const {
    notification,
    isSubmitting,
    onDismissNotification,
    onFlushLiveUpdate,
  } = props
  const { info, icon, text } = notification

  const button = info.status === 'buffered'
    ? (
      <AnalyticsClick
        className={ styles.liveUpdateButtonWrapper }
        category='site_controls-notification_tray'
        action='click-update_now_cta'
      >
        <Button
          size='responsive'
          theme='green'
          onClick={ () => onFlushLiveUpdate(info) }
          disabled={ isSubmitting }
          isSubmitting={ isSubmitting }
        >
          Update Now
        </Button>
      </AnalyticsClick>
    ) : (
      <TextButton onClick={ () => onDismissNotification(notification.id) }>
        Dismiss
      </TextButton>
    )

  return (
    <div className={ cn(styles.itemInner, { [styles.withIcon]: !!icon }) }>
      <section className={ styles.itemContent }>
        { icon && (
          <div className={ styles.icon }>
            <Icon kind={ icon } />
          </div>
        )}
        <section className={ styles.itemText }>
          { text }
        </section>
        <section className={ styles.buttons }>
          { button }
        </section>
      </section>
    </div>
  )
}

const mapStateToProps = (state: State, _ownProps: LiveUpdateNotificationItemOwnProps): LiveUpdateNotificationItemStateProps => ({
  isSubmitting: state.app.linkage.liveUpdate.isFlushing,
})

const mapDispatchToProps: LiveUpdateNotificationItemDispatchProps = {
  onFlushLiveUpdate: flushLiveUpdateActionCreator.request,
  onDismissNotification: dismissNotificationActionCreator,
}

export const LiveUpdateNotificationItem = connect<
  LiveUpdateNotificationItemStateProps,
  LiveUpdateNotificationItemDispatchProps,
  LiveUpdateNotificationItemOwnProps
>(mapStateToProps, mapDispatchToProps)(LiveUpdateNotificationItemComponent)
